import {MessagesI18n} from '@/locales/base.message.locales';

export const messages: MessagesI18n = {
  confirm_action: 'Por favor, confirme sua ação !',
};
